<template>
  <v-app>
    <v-main>
      <v-layout align-center justify-center>
        <v-card min-width="80%" class="elevation-12">
          <v-toolbar color="white info--text" dark flat>
            <v-toolbar-title>Envio de Arquivos</v-toolbar-title>
          </v-toolbar>
          <v-divider />
          <div>
            <v-row>
              <v-col cols="9" sm="10" md="10">
                <v-file-input
                  @change="LoadFileInBase64"
                  v-model="fFileUpload"
                />
              </v-col>
            </v-row>
            <div class="white info--text" v-if="fUploadInProcess">
              <v-icon class="white info--text">mdi-alert</v-icon>
              Enviando documento, por favor aguarde...
            </div>
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="white"
                class="text-none info--text"
                @click="UploadFile"
                :disabled="!fEnableSend || fUploadInProcess"
              >
                <v-icon>mdi-upload</v-icon>Enviar Arquivo
              </v-btn>
            </v-card-actions>
          </div>
        </v-card>
      </v-layout>
    </v-main>
  </v-app>
</template>

<script>
import api from '@/services/api'

const TABELAFIPE = 0
const MOVIMENTO = 1

export default {
  name: 'Home',
  /*components: {
    FileUpload
  }*/
  data() {
    return {
      fPostData: {
        FileContentBase64: null,
        FileName: '',
        IdLoteMovimento: 0,
        TypeFile: 0
      },
      fFileUpload: null,
      fEnableSend: false,
      fUploadInProcess: false
    }
  },
  mounted() {
    if (this.$route.fullPath == '/uploadfile/tabelafipe') {
      this.fPostData.TypeFile = TABELAFIPE
    } else {
      this.fPostData.IdLoteMovimento = this.$route.params.idlotemovimento
      this.fPostData.TypeFile = MOVIMENTO
    }
  },
  methods: {
    UploadFile: function() {
      this.fUploadInProcess = true
      this.fPostData.FileName = this.fFileUpload.name

      api
        .post('/documento', this.fPostData)
        .then(() => {
          alert(
            'Envio do Arquivo realizado com sucesso! Verifique a tela de itens do lote para acompanhar o andamento da importação dos itens, você receberá um e-mail quando o processo terminar!'
          )
          this.fUploadInProcess = true
          window.close()
        })
        .catch(lError => {
          console.log(lError)
          alert(
            'Envio do Arquivo não realizado! ' + lError.response.data.MsgErro
          )
        })
        .then(() => {
          this.fUploadInProcess = false
        })
    },
    LoadFileInBase64: function() {
      var file = document.querySelector('input[type=file]').files[0]
      var reader = new FileReader()
      var vm = this
      reader.onload = function(e) {
        vm.fPostData.FileContentBase64 = e.target.result
        vm.fEnableSend = true
      }
      reader.onerror = function(error) {
        alert(error)
      }
      vm.fEnableSend = false
      if (file != undefined) {
        reader.readAsDataURL(file)
      }
    }
  }
}
</script>
